import { StatusBanner } from '@wix/wix-chatbot-common/browser';

import { getLast } from '../../../util/guards';
import { IAgent } from '../messageCreators';
import { TRootState } from '../reducers';
import { IAnnouncementState } from '../reducers/types';

export const selectIsEnable = (state: TRootState): boolean => {
  return state.header.isEnable;
};

export const selectAlert = (
  state: TRootState,
): IAnnouncementState | undefined => {
  return state.header.announcement;
};

export const selectStatusBannerData = (
  state: TRootState,
): StatusBanner | undefined => {
  return state.header.statusBanner;
};

export const hideStatusBannerData = (state: TRootState): boolean => {
  return state.header.hideStatusBanner;
};

export const selectOnlineAgent = (state: TRootState): IAgent | undefined => {
  return getLast(state.header.onlineAgents);
};
